import React, { useEffect, useRef, useState } from "react";
import styles from "../login/login.module.scss";
import rocket from "../../assests/signUpRocket.png";
import { useNavigate } from "react-router-dom";
import { FaFacebook } from "react-icons/fa";
import { FaApple } from "react-icons/fa6";
import { FcGoogle } from "react-icons/fc";

const Login = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ email: "", password: "" });

  const MyRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );
    if (MyRef.current) observer.observe(MyRef.current);
    return () => {
      if (MyRef.current) observer.unobserve(MyRef.current);
    };
  }, []);

  const navigateSignup = () => navigate("/signup");

  const handleLogin = () => {
    const newErrors = {};
    if (!email.trim()) newErrors.email = "Email is required.";
    if (!password.trim()) newErrors.password = "Password is required.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      console.log("Logging in...");
    }
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (errors.email) setErrors((prev) => ({ ...prev, email: "" }));
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (errors.password) setErrors((prev) => ({ ...prev, password: "" }));
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <div className={visible ? styles.signUpImgEvent : styles.signUpImg}>
            <img src={rocket} alt="" ref={MyRef} />
          </div>
          <h1>Let's Get Started</h1>
        </div>

        <div className={styles.right}>
          <div className={styles.form}>
            <h2>Sign in / Log in</h2>
            <p>
              Don't have an account?{" "}
              <a onClick={navigateSignup} style={{ color: "blue", cursor: "pointer" }}>
                Sign up
              </a>
            </p>

            <div className={styles.formContent}>
              <div className={styles.input}>
                <label htmlFor="">E-mail ID*</label>
                <input
                  type="text"
                  placeholder="Enter Your Email ID"
                  value={email}
                  onChange={handleEmailChange}
                />
                {errors.email && <div className={styles.errorText}>{errors.email}</div>}
              </div>

              <div className={styles.input}>
                <label htmlFor="">Password*</label>
                <input
                  type="password"
                  placeholder="Enter Your password"
                  value={password}
                  onChange={handlePasswordChange}
                />
                {errors.password && <div className={styles.errorText}>{errors.password}</div>}
              </div>

              <div className={styles.password}>
                <div className={styles.rememberPassword}>
                  <input type="checkbox" />
                  <div>Remember Me</div>
                </div>
                <div>Forgot Password?</div>
              </div>

              <div className={styles.verifyBtn} onClick={handleLogin}>
                Login
              </div>

              {/* <p>or continue with</p>
              <div className={styles.formIcons}>
                <div><FaFacebook /></div>
                <div><FaApple /></div>
                <div><FcGoogle /></div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
